import Table from '@/src/components/Antd/Table/SizeFittingTable';
import { QuestionCircleFilled } from '@ant-design/icons';
import { get } from 'lodash';
import React from 'react';
import Check from 'src/components/Antd/Checkbox/Checkbox';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import WhiteBackgroundTooltip, {
  TooltipContainer,
  TooltipContent,
  TooltipTitle,
} from 'src/components/GlobalTooltip/WhiteBackgroundTooltip';
import Html from 'src/constrains/HtmlToText';
import Actions from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableActions';
import Search from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableSearch';
import SectionWrapper from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/SectionWrapper';
import { EnumTablePosition } from 'src/types/common/common';
import css from './css.module.less';
import Modal from './Modal';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const mainlandCode = 'CN';

const CrossBoardSetting = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data, onChange, setHasModified, isPrimary, disableEdit } = props;
  const [visible, setVisible] = React.useState(false);
  const [selected, setSelected] = React.useState(null);
  const [searchText, setSearchText] = React.useState('');
  const handleHasModified = () => {
    setHasModified(true);
  };
  const handleOnSelect = (obj) => {
    setSelected(obj);
    setVisible(true);
  };

  const handleOnCancel = () => {
    setSelected(null);
    setVisible(false);
  };
  // const [test, setTest] = React.useState({
  //   Au: { disableDrag: true, hideDragger: false },
  //   Us: { disableDrag: false, hideDragger: true },
  //   Hk: { disableDrag: true, hideDragger: true },
  // });
  //const [displayData, setDisplayData] = React.useState(data || []);

  const handleOnReminderChange = (reminder) => {
    handleHasModified();
    const code = get(selected, 'country.code');
    const _data = [...data];
    _data.forEach((i) => {
      const _code = get(i, 'country.code');
      if (_code === code) {
        i.reminder = reminder;
      }
    });
    if (onChange) {
      onChange(_data);
      handleOnCancel();
    }
  };

  const handleOnVerificationChange = (code, idVerification) => {
    handleHasModified();
    const _data = [...data];

    _data.forEach((i) => {
      const _code = get(i, 'country.code');
      if (_code === code) {
        i.idVerification = idVerification;
      }
    });

    if (onChange) {
      onChange(_data);
    }
  };

  const handleOnSearch = (text) => {
    setSearchText(text);
  };

  const currentData = React.useMemo(() => {
    if (!searchText) {
      return data;
    } else {
      return data.filter((i) => {
        const name = get(i, 'country.name').toLowerCase();
        const _s = searchText.toLowerCase();
        return name.indexOf(_s) > -1;
      });
    }
  }, [searchText, data]);

  return (
    <SectionWrapper
      title={getI18n('salesChannelCheckout.index.crossBorderSetting')}>
      {visible && (
        <Modal
          visible={true}
          data={(selected || {}).reminder}
          onOk={handleOnReminderChange}
          onCancel={handleOnCancel}
        />
      )}
      <div className={css.serach}>
        <Search
          onSearch={handleOnSearch}
          placeholder={getI18n(
            'salesChannelCheckout.index.searchcountryregion',
          )}
        />
      </div>
      <div className={css.container}>
        <Table
          //availabilityConfig={test}

          pagination={false}
          rowKey={(record) => {
            return get(record, 'country.code');
          }}
          dataSource={currentData || []}
          columns={col(
            isPrimary,
            handleOnVerificationChange,
            handleOnSelect,
            disableEdit,
            { getI18n },
          )}
          id='SalesChannelCheckoutCrossBoardSettingTable'

          // rowDeleteFunc={deleteProduct}
        />
      </div>
    </SectionWrapper>
  );
};
export default CrossBoardSetting;
const col = (
  isPrimary,
  onVerificationChange,
  onReminderSelect,
  disableEdit,
  { getI18n },
) => {
  return isPrimary
    ? [
        {
          title: getI18n('general.countryRegion'),
          key: 'country',
          default: true,
          childGenerate: (url, record) => {
            const name = get(record, `country.name`);
            return (
              <NoWrapContainer>
                <GlobalTooltip title={name}>{name}</GlobalTooltip>
              </NoWrapContainer>
            );
          },
          width: 192,
        },
        {
          title: getI18n('salesChannelCheckout.index.crossBorderReminder'),
          key: 'reminder',
          default: true,
          childGenerate: (url, record) => {
            const reminder = get(record, `reminder`);
            const text = reminder || '';
            return <Html html={text} hasTooltip width={550 - 100} />;
          },
          minWidth: 550,
        },
        {
          titleGenerate: () => {
            return (
              <div className={css.idContainer}>
                {getI18n('salesChannelCheckout.index.iDVerification')}
                <WhiteBackgroundTooltip
                  title={
                    <TooltipContainer>
                      <TooltipTitle>
                        {getI18n('salesChannelCheckout.index.iDVerification')}
                      </TooltipTitle>
                      <TooltipContent>
                        {getI18n(
                          'salesChannelCheckout.index.iDVerificationTip',
                        )}
                      </TooltipContent>
                    </TooltipContainer>
                  }
                  placement='rightTop' //overlayClassName
                >
                  <QuestionCircleFilled className={css.icon} />
                </WhiteBackgroundTooltip>
              </div>
            );
          },
          key: 'Verification',
          default: true,
          position: EnumTablePosition.mid,
          childGenerate: (url, record) => {
            const code = get(record, `country.code`);
            const idVerification = get(record, `idVerification`);
            const isMainland = code === mainlandCode;
            return isMainland ? (
              <Check
                checked={idVerification}
                disabled={disableEdit}
                onChange={(e) => {
                  onVerificationChange(code, e);
                }}
              />
            ) : null;
          },
          width: 190,
        },
        disableEdit
          ? {}
          : {
              titleGenerate: () => {
                return (
                  <div className={css.idContainer}>
                    {getI18n(
                      'general.advancedFilters.commonStoreProductsWithTable.actions',
                    )}
                  </div>
                );
              },
              key: 'Action',
              default: true,
              position: EnumTablePosition.mid,
              childGenerate: (url, record, index) => {
                // const code = get(record, `country.code`);
                // const idVerification = get(record, `idVerification`);
                // const isMainland = code === mainlandCode;
                return (
                  <Actions
                    onEdit={() => {
                      onReminderSelect(record);
                    }}
                  />
                );
              },
              width: 120,
            },
      ]
    : [
        {
          title: getI18n('general.countryRegion'),
          key: 'country',
          default: true,
          childGenerate: (url, record) => {
            const name = get(record, `country.name`);
            return (
              <NoWrapContainer>
                <GlobalTooltip title={name}>{name}</GlobalTooltip>
              </NoWrapContainer>
            );
          },
          width: 192,
        },
        {
          title: getI18n('salesChannelCheckout.index.crossBorderReminder'),
          key: 'reminder',
          default: true,
          childGenerate: (url, record) => {
            const reminder = get(record, `reminder`);
            const text = reminder || '';
            return (
              <NoWrapContainer>
                <GlobalTooltip title={text}>{text}</GlobalTooltip>
              </NoWrapContainer>
            );
          },
          minWidth: 550,
        },
        disableEdit
          ? {}
          : {
              titleGenerate: () => {
                return (
                  <div className={css.idContainer}>
                    {getI18n(
                      'general.advancedFilters.commonStoreProductsWithTable.actions',
                    )}
                  </div>
                );
              },
              key: 'Action',
              default: true,
              position: EnumTablePosition.mid,
              childGenerate: (url, record, index) => {
                // const code = get(record, `country.code`);
                // const idVerification = get(record, `idVerification`);
                // const isMainland = code === mainlandCode;
                return (
                  <Actions
                    onEdit={() => {
                      onReminderSelect(record);
                    }}
                  />
                );
              },
              width: 120,
            },
      ];
};
